/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const setReqInvoiceCalcData = (data) => {
  return {
    type: actionTypes.SET_REQ_INVOICE_DATA,
    payload: data,
  };
};

export const setErrorMessagesData = (messages) => {
  return {
    type: actionTypes.SET_ERROR_MESSAGES_REQ_INV_CAL,
    payload: messages,
  };
};

export const resetRequestInvoiceCalculationStore = () => {
  return {
    type: actionTypes.RESET_REQUEST_INVOICE_CALCULATION_STORE,
  };
};

export const dispatchManufacturersByPQR = (data) => {
  return {
    type: actionTypes.GET_MANUFACTURERS_BY_REQ_INV_CAL,
    payload: data,
  };
};

export const getManufacturersByPQR = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_MANUFACTURERS_BY_PQR, values)
    .then((response) => {
      return dispatch(dispatchManufacturersByPQR(response.data));
    })
    .catch(() => {
      dispatch(dispatchManufacturersByPQR([]));
    });
};

export const dispatchCalculateInvoice = (data) => {
  return {
    type: actionTypes.CALCULATE_INVOICE,
    payload: data,
  };
};

const buildCalculateInvoicePayload = (responseData, runProcedure) => ({
  ...responseData,
  runProcedure,
});

export const calculateInvoice = (values) => (dispatch) => {
  dispatch(dispatchCalculateInvoice(null));

  return axios
    .post(serviceEndPoint.CALCULATE_INVOICE, values)
    .then((response) => {
      return dispatch(
        dispatchCalculateInvoice(
          buildCalculateInvoicePayload(response.data, values.runProcedure)
        )
      );
    })
    .catch((error) => {
      const responseData = error?.response?.data;
      if (String(responseData?.status) === '001') {
        return dispatch(
          dispatchCalculateInvoice(
            buildCalculateInvoicePayload(responseData, values.runProcedure)
          )
        );
      }
      dispatch(
        dispatchCalculateInvoice({
          error: responseData || 'API failed',
          runProcedure: values.runProcedure,
        })
      );
    });
};

export const setDefaultQtr = (data) => {
  return {
    type: actionTypes.SET_DEFAULT_QTR,
    defaultQtrRIC: data,
  };
};

export const getMaxQuarterForFreezeDt = () => (dispatch) => {
  return axios
    .get(`${serviceEndPoint.GET_MAXQUARTER_PLUS_ONE}`)
    .then((response) => {
      return dispatch(setDefaultQtr(response.data));
    })
    .catch((response) => {
      dispatch(setDefaultQtr(response.date));
    });
};
